import StudentAppointmentNotification from "./StudentAppointmentNotification.vue"
import AdultSummaryReportNotification from "./AdultSummaryReportNotification.vue"
import AdultAppointmentNotification from "./AdultAppointmentNotification.vue"
import StudentPbisPointNotification from "./StudentPbisPointNotification.vue"

export const notificationMappings = {
  SUMMARY_REPORT_REQUEST_NOTIFICATION: "AdultSummaryReportNotification",
  STUDENT_APPOINTMENT_NOTIFICATION: "StudentAppointmentNotification",
  ADULT_APPOINTMENT_NOTIFICATION: "AdultAppointmentNotification",
  STUDENT_PBIS_POINT_NOTIFICATION: "StudentPbisPointNotification"
}

export const notificationComponents = {
  StudentAppointmentNotification,
  AdultSummaryReportNotification,
  AdultAppointmentNotification,
  StudentPbisPointNotification
}
